import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input"];

  static values = {
    fillColor: {
      default: "#e45f00",
      type: String,
    },
    backgroundColor: {
      default: "#f2f2f2",
      type: String,
    },
  };

  declare readonly inputTarget: HTMLInputElement;
  declare readonly fillColorValue: string;
  declare readonly backgroundColorValue: string;

  private updateSlider!: (event: Event) => void;
  private animationFrame: number | null = null;

  connect() {
    this.updateSlider = this.updateSliderBackground.bind(this);
    this.inputTarget.addEventListener("input", this.updateSlider);

    this.updateSliderBackground();
  }

  disconnect(): void {
    this.inputTarget.removeEventListener("input", this.updateSlider);
    if (this.animationFrame !== null) {
      cancelAnimationFrame(this.animationFrame);
    }
  }

  onIput() {
    if (this.animationFrame === null) {
      this.animationFrame = requestAnimationFrame(() => {
        this.updateSliderBackground();
        this.animationFrame = null;
      });
    }
  }

  updateSliderBackground() {
    const value =
      ((Number(this.inputTarget.value) - Number(this.inputTarget.min)) /
        (Number(this.inputTarget.max) - Number(this.inputTarget.min))) *
      100;

    this.inputTarget.style.background = `
      linear-gradient(to right,
      ${this.fillColorValue} 0%,
      ${this.fillColorValue} ${value}%,
      ${this.backgroundColorValue} ${value}%,
      ${this.backgroundColorValue} 100%)
    `;
  }
}
